function loader() {
    let loading = document.querySelector('body.loading');
    if (loading) {
        if (loading.classList.contains('loading')) {
            loading.classList.add('loading--finished');

            setTimeout(function () {
                loading.classList.remove('loading--finished');
                loading.classList.remove('loading');

                document.dispatchEvent(new CustomEvent('bodyLoadingFinished'));
            }, 120);
        }
    }
}

if (document.readyState === 'loading') {  // Loading hasn't finished yet
    document.addEventListener('DOMContentLoaded', loader);
} else {  // `DOMContentLoaded` has already fired
    loader();
}